import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, mergeMap, of } from 'rxjs'
import {
  route_to_action,
  show_display_id_after_created_action,
  show_error_action,
  show_success_msg_after_updation_action
} from '../action/common/common.action'
import { AnnouncementService } from 'src/app/services/announcement/announcement.service'
import {
  fetch_announcement_details,
  fetch_announcement_details_success,
  load_announcement_summary_action,
  load_announcement_summary_success_action,
  save_announcement_action,
  save_announcement_success_action,
  update_announcement_action,
  update_announcement_success_action
} from '../action/announcement.action'

@Injectable()
export class AnnouncementEffects {
  constructor(private actions$: Actions, private announcementService: AnnouncementService) {}
  load_announcement_summary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_announcement_summary_action),
      mergeMap(data =>
        this.announcementService.invokeAnnouncementSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(announcementResponce => load_announcement_summary_success_action({ announcement: announcementResponce })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  save_announcement_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_announcement_action),
      mergeMap(({ announcement, files, routeTo }) =>
        this.announcementService.callSaveApi(announcement, files).pipe(
          mergeMap(response => [
            save_announcement_success_action({
              announcement: response
            }),
            route_to_action({ routeTo }),
            show_display_id_after_created_action({
              moduleName: 'Announcement / Circular',
              displayId: response?.displayId
            })
          ]),

          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  update_announcement_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(update_announcement_action),
      mergeMap(({ id, announcement, files, routeTo }) =>
        this.announcementService.callUpdateApi(id, announcement, files).pipe(
          mergeMap(response => [
            update_announcement_success_action({
              announcement: response
            }),
            route_to_action({ routeTo }),
            show_success_msg_after_updation_action({
              moduleName: 'Announcement / Circular'
            })
          ]),

          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_announcement_details$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetch_announcement_details),
      mergeMap(({ id }) =>
        this.announcementService.callAnnouncementDetailsApi(id).pipe(
          mergeMap(announcement => [fetch_announcement_details_success({ announcement })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
